export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/X.08d39327.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};